import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation NarrativeGenerateCharacters($uid: String!){
        narrative_auto_generate_characters (uid: $uid) {
            success
        }
    }
`;

export async function narrativeGenerateCharacters(uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ narrative_auto_generate_characters: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.narrative_auto_generate_characters;
}
